import carouselMobile from '../modules/carouselMobile';

carouselMobile(768, '.unity__carousel');